import {
  segmentMemberColumnKeys,
  segmentMemberSchema,
} from "@redotech/redo-model/marketing/segments/segment-types";
import { segmentSchema } from "@redotech/redo-model/marketing/segments/segment-zod-schema";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getSegmentMembersBaseInputSchema = z.object({
  page: z.number(),
  pageSize: z.number(),
  sort: z
    .object({
      direction: createEnum(SortDirection),
      key: createEnum(segmentMemberColumnKeys),
    })
    .nullable(),
});
export type GetSegmentMembersBaseInput = z.infer<
  typeof getSegmentMembersBaseInputSchema
>;

export const getSegmentMembersPreviewInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("dynamic-segment-preview").or(z.literal("segment-preview")), // safe to delete "segment-preview" after 10-31-2025
    segment: segmentSchema,
    searchString: z.string().optional(),
  });
export type GetSegmentMembersPreviewInput = z.infer<
  typeof getSegmentMembersPreviewInputSchema
>;

export const getSegmentMembersExportInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("customer-group-export"),
    customerGroupId: zExt.objectId(),
  });
export type GetSegmentMembersExportInput = z.infer<
  typeof getSegmentMembersExportInputSchema
>;

export const getSegmentMembersStaticInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("static-segment-preview"),
    customerGroupId: zExt.objectId(),
    searchString: z.string().optional(),
  });
export type GetSegmentMembersStaticInput = z.infer<
  typeof getSegmentMembersStaticInputSchema
>;

// TODO: delete this soon after it deploys (intended for backwards compatibility during deployment only)
const getSegmentMembersLegacyInputSchema = getSegmentMembersBaseInputSchema
  .extend({ segment: segmentSchema, searchString: z.string().optional() })
  .transform((data) => ({ mode: "dynamic-segment-preview" as const, ...data }));

export const getSegmentMembers = {
  name: "getSegmentMembers" as const,
  input: z.union([
    getSegmentMembersPreviewInputSchema,
    getSegmentMembersExportInputSchema,
    getSegmentMembersStaticInputSchema,
    getSegmentMembersLegacyInputSchema,
  ]),
  output: z.array(segmentMemberSchema),
};
